import React from 'react';

const ProfileSection = ({ data, additionalContent }) => {
  const source = data.thumbnail || data.PhotoUrl || '';
  const alt = data.title || data.DisplayName;
  const name = data.title || data.DisplayName;
  const description = data.description || data.biography;

  return (
    <div className="profile-main">
      <div className="profile-image">
        <img
          src={source}
          alt={alt}
        />
      </div>
      <div className="profile-content">
        <div>
          <div className="profile-name">{name}</div>
          <div className="profile-description">
            {description}
          </div>
        </div>
        {/*{profile.tag && (*/}
        {/*<div className="profile-tags">*/}
        {/*<Tag className={`tag-${profile.tag.type}`}>*/}
        {/*{profile.tag.name}*/}
        {/*</Tag>*/}
        {/*</div>*/}
        {/*)}*/}

        {/* <div className="profile-name">{currentChannel.title}</div> */}
        {/*{profile.tag && (*/}
        {/*<div className="profile-tags">*/}
        {/*<Tag className={`tag-${profile.tag.type}`}>*/}
        {/*{profile.tag.name}*/}
        {/*</Tag>*/}
        {/*</div>*/}
        {/*)}*/}
        {/* <div className="profile-description">
          {currentChannel.description}
        </div> */}
        {additionalContent}
      </div>
    </div>
  )
}

export default ProfileSection;


// WEBPACK FOOTER //
// ./src/components/Modules/ProfileSection/index.js